var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"business-contact-company-edit","toptitle":"Unternehmen bearbeiten","title":_vm.businessContactCompany.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('business-contact-company-form',{attrs:{"businessContactCompany":_vm.businessContactCompany,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }